import CandidateExpertise from './CandidateExpertise.container';

export default CandidateExpertise;
